export const searchQueryParamName = "search";
export const pageQueryParamName = "page";
